import * as yup from "yup";

export const workOrderStateSchema = (maxOrdinal?: number) =>
  yup.object().shape({
    name: yup.string().required().label("Name"),
    ordinal: yup
      .number()
      .required()
      .min(1)
      .max(
        (maxOrdinal ?? 0) + 1,
        "Order cannot be greater than the next available position"
      )
      .label("Order"),
    showInDispatch: yup.boolean().label("Show In Dispatch"),
    showForTech: yup.boolean().label("Show For Tech"),
  });
